<!--<div id="overlay">-->
<!--  <ap-loading *ngIf="startLoader" id="text" class="loader-class" [colorName]="'a-primary'">-->
<!--  </ap-loading>-->
<!--</div>-->
@if (startLoader) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
                               (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form217">
    <dst-template-header [parentFormGroup]="form217" (formOptionChanged)="onFormOptionChanged($event)"
                         (consolGroupChanged)="OnConsolGroupChanged($event)"></dst-template-header>
    <div class="section-content">
      <div class="row" style="margin: 5px 0;">
        <div class="col-md-4 row">Name as shown on return</div>
        <div class="col-md-4 pr-0" style="margin-left: 40px;margin-right: -30px;"><span class="template-color-blue">{{ dcnName }}</span>
        </div>

        <div class="col-md-4 p-0">
          Identifying number:
          <span class="template-color-blue pl-3">{{ dcnIDNum }}</span>
        </div>
      </div>
      <div  class="row" style="margin: 5px 0;">
        <div class="d-flex align-items-center col-md-4 row">
          <span>Please specify the LEID of the Purchaser/Seller</span>
        </div>
        <div class="col-md-4" style="margin-top: -20px;margin-left: 40px;margin-right: -30px;">
          <dst-template-leid-selector [label]="''" [labelId]="'100'"
                                      (onSelectedLEChanged)="onTransferorChanged($event)" class="required-field pl-3">
          </dst-template-leid-selector>
        </div>
      </div>


      <div class="row" style="margin: 5px 0;">
        <div class="col-md-4 row"><span>Name of Purchaser/Seller:</span></div>
        <div class="col-md-8 pl-3" style="margin-left: 40px;margin-right: -30px;">@if (transferor) {
<span class="template-color-blue">{{transferor.ENTITY}}</span>
}</div>
      </div>

      <div class="row"  style="margin: 5px 0;">
        <div class="col-md-4 row">
          Check the box that identifies you:
        </div>
        <div class="col-md-8 pl-3" style="margin-left: 40px;margin-right: -30px;">
          <ap-radio-group [ariaLabel]="'Check the box that identifies you:'">
            <ap-radio [value]="'Purchaser'" [(ngModel)]="PurchaserOrSeller" [ngModelOptions]="{standalone: true}" [name]="'radio-group-1'" (onChange)="check1c('Purchaser')" [styleClass]="'required-field-radio'">
              <span>Purchaser</span>
            </ap-radio>
            <ap-radio [value]="'Seller'" [(ngModel)]="PurchaserOrSeller" [ngModelOptions]="{standalone: true}" [name]="'radio-group-1'" (onChange)="check1c('Seller')" [styleClass]="'required-field-radio'">
              <span>Seller</span>
            </ap-radio>
          </ap-radio-group>
        </div>
      </div>
      <br/>
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;Part I</strong>&nbsp;&nbsp;&nbsp;&nbsp; <strong>General Information</strong>
          </td>
        </tr>
        </tbody>
      </table>

      <div formGroupName="partOne" class="section-content ap-form-field-my-wrapper part-one">
        <div class="section-content">
          <div class="row">
            <div class="col-md-4 pr-0">
              Is the Other Party to the Transaction in Legal Entity Database?
            </div>
            <div class="col-md-8" style="margin-left: 7px;margin-right: -30px;">
              <ap-radio-group [ariaLabel]="'Is the Other Party to the Transaction in Legal Entity Database?'">
                <ap-radio [value]="'Yes'" [(ngModel)]="Choice204e" [ngModelOptions]="{standalone: true}" [name]="'radio-group-2'" (onChange)="check1('Yes'); Choice204f = ''" [styleClass]="'required-field-radio'">
                  <span>Yes</span>
                </ap-radio>
                <ap-radio [value]="'No'" [(ngModel)]="Choice204e" [ngModelOptions]="{standalone: true}" [name]="'radio-group-2'" (onChange)="check1('No')" [styleClass]="'required-field-radio'">
                  <span>No</span>
                </ap-radio>
              </ap-radio-group>
            </div>
          </div>
          <br />

          <div [hidden]="!(Choice204e === 'Yes')">
            <br/>
            <div class="row">
              <div class="col-md-4">
                Please specify the LEID of the other party to the transaction
              </div>
              <div class="col-md-8" style="margin-left: 7px;margin-right: -30px;">
                <dst-template-leid-selector [label]="''"
                                            [labelId]="'100'" class="required-field" (onSelectedLEChanged)="onTransfereeChanged($event)">
                </dst-template-leid-selector>
              </div>
            </div>
            <ol class="list-content">
              <li>
                <div class="entity-details">
                  <span class="col-md-4 pl-0">Name of other party to the transaction:</span>
                  <span class="template-color-blue col-md-8">{{!transferee ? '' : transferee.ENTITY}}</span>
                </div>
                <div class="entity-details">
                  <span class="col-md-4 pl-0">Identifying number:</span>
                  <span class="template-color-blue col-md-8">{{!transferee ? '' : (transferee.EIN ? transferee.EIN : 'N/A')}}</span>
                </div>
                @if (transferee) {
<div class="entity-details">
                  <span class="col-md-4 pl-0">Address Line1</span>
                  <span class="template-color-blue col-md-8">{{transferee.ADDRESS1}}</span>
                </div>
}
                @if (transferee) {
<div class="entity-details">
                  <span class="col-md-4 pl-0">Address Line2</span>
                  <span class="template-color-blue col-md-8">{{transferee.ADDRESS2}}</span>
                </div>
}
                @if (transferee) {
<div class="entity-details">
                  <span class="col-md-4 pl-0">{{ transferee.COUNTRY === 'US' ? 'City:' : 'City / Town:'}}</span>
                  <span class="template-color-blue col-md-8">{{transferee.CITY}}</span>
                </div>
}
                @if (transferee) {
<div class="entity-details">
                  <span class="col-md-4 pl-0">{{transferee.COUNTRY === 'US' ? 'State': 'Province Or State'}}</span>
                  <span class="template-color-blue col-md-8">{{ transferee.COUNTRY === 'US' ? transferee.STATE : (transferee.STATEINC || 'N/A')}}</span>
                </div>
}
                @if (transferee) {
<div class="entity-details">
                  <span class="col-md-4 pl-0">Country</span>
                  <span class="template-color-blue col-md-8">{{transferee.COUNTRYNAME}}</span>
                </div>
}
                @if (transferee) {
<div class="entity-details">
                  <span class="col-md-4 pl-0">{{transferee.COUNTRY === 'US' ? 'Zip Code:' : 'Postal Code:'}}</span>
                  <span class="template-color-blue col-md-8">{{transferee.ZIP}}</span>
                </div>
}
              </li>
            </ol>
          </div>
          <div [hidden]="!(Choice204e === 'No')">
            <div class="row">
              <div class="col-md-4">
                Is the Other Party a US Entity?
              </div>
              <div class="col-md-8" style="margin-left: 7px;margin-right: -30px;">
                <ap-radio-group [ariaLabel]="'Is the Other Party a US Entity?'">
                  <ap-radio [value]="'Yes'" [(ngModel)]="Choice204f" [ngModelOptions]="{standalone: true}" [name]="'radio-group-3'" (onChange)="check1b('Yes')" [styleClass]="'required-field-radio'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="'No'" [(ngModel)]="Choice204f" [ngModelOptions]="{standalone: true}" [name]="'radio-group-3'" (onChange)="check1b('No')" [styleClass]="'required-field-radio'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
              </div>
            </div>
            <br/>
            <div [hidden]="(Choice204f === '')">
              <ol class="list-content m-0">
                <li>
                  <div class="row">
                    <div class="col-md-4">
                      Name of other party to the transaction
                    </div>
                    <div class="col-md-8">
                      <dst-custom-input class="required-field custom-input-100 w-100"
                                        [label]="''" [maxLength]="150" [value]="NameOfOP" (valChange)="NameOfOP = $event;">
                      </dst-custom-input>
                    </div>
                  </div>

                  <div class="row pb-2">
                    <div class="col-md-4">
                      Identifying Number
                    </div>
                    <div class="col-md-8">
                      <ap-radio-group [ariaLabel]="'Identifying Number'">
                        <ap-radio [value]="'ein'" [(ngModel)]="einSsnRadio" [ngModelOptions]="{standalone: true}" [name]="'radio-group-4'" (onChange)="checkEINorSSN('ein')">
                          <span>EIN or</span>
                        </ap-radio>
                        <ap-radio [value]="'ssn'" [(ngModel)]="einSsnRadio" [ngModelOptions]="{standalone: true}" [name]="'radio-group-4'" (onChange)="checkEINorSSN('ssn')" [styleClass]="'a-mx-10'">
                          <span>SSN?</span>
                        </ap-radio>
                      </ap-radio-group>
                    </div>
                  </div>

                  <div class="row pb-4">
                    <div class="col-md-4">
                    </div>
                    @if (einSsnRadio === 'ein') {
<div class="col-md-4">
                     <dst-custom-input class="required-field" [label]="''" [maxLength]="9" [value]="EinOfOtherParty1"
                                        (valChange)="EinOfOtherParty1 = $event;">
                      </dst-custom-input>
                    </div>
}
                    @if (einSsnRadio === 'ssn') {
<div class="col-md-4" style="padding-left: 0px;">
                      <ap-field [title]="''" [fieldId]="'1'" [type]="'appkit-number'" [format]="''" [styleClass]="'required-field'" [hideTitleOnInput]="true">

                        <input appkit-field [(ngModel)]="SSNOfOtherParty1" [ngModelOptions]="{standalone: true}" [placeholder]="''" />
                      </ap-field>
                     </div>
}
                  </div>

                  <!-- <div class="row pb-2" *ngIf="Choice204f !== 'Yes'">
                    <div class="col-md-4">
                    </div>
                    <div class="col-md-4" style="padding-left: 0px;">
                      <ap-field [fieldId]="'1'" [title]="''" [hideTitleOnInput]="true">
                        <input appkit-field formControlName="EinOfOtherParty1" [(ngModel)]="EinOfOtherParty1"
                          class="required-field" aria-label="1" />
                      </ap-field>

                    </div>
                  </div> -->
                  @if ((EinOfOtherParty1 === '' && einSsnRadio === 'ein') || ((SSNOfOtherParty1 === '' || SSNOfOtherParty1 == null) && einSsnRadio === 'ssn')) {
<div class="row pb-4">
                    <div class="col-md-4">
                      EIN Missing Reason:
                    </div>
                    <div class="col-md-4">
                      <ap-dropdown [list]="EINMissingReason1" [selectType]="'single'" class="ein-reason-field"
                                   [(ngModel)]="selectedEINMissing1Item" [ngModelOptions]="{standalone: true}"
                                   [title]="'** Please select the missing reason **'" [hideTitleOnInput]="true" [inputAriaLabel]="'EIN Missing Reason'"
                                   (onSelect)="missingReason1($event)">
                        @for (item of EINMissingReason1; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setAriaLabel(item, '** Please select the missing reason **')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                      </ap-dropdown>
                    </div>
                  </div>
}

                  <div class="row">
                    <div class="col-md-4">
                      Address Line 1
                    </div>
                    <div class="col-md-8">
                      <dst-custom-input class="required-field custom-input-100 w-100"
                                        [label]="''" [maxLength]="35" [value]="AddressOfOtherParty1"
                                        (valChange)="AddressOfOtherParty1 = $event;">
                      </dst-custom-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      Address Line 2
                    </div>
                    <div class="col-md-8">
                      <dst-custom-input class="custom-input-100 w-100" [label]="''" [maxLength]="35" [value]="AddressOfOtherParty2"
                                        (valChange)="AddressOfOtherParty2 = $event;"></dst-custom-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      City
                    </div>
                    <div class="col-md-8">
                      <dst-custom-input class="required-field custom-input-100 w-100" [label]="''" [maxLength]="50" [value]="CityOfOtherParty"
                                        (valChange)="CityOfOtherParty = $event;"></dst-custom-input>
                    </div>
                  </div>
                  @if (Choice204f === 'Yes') {
<div class="row">
                    <div class="col-md-4">
                      State
                    </div>
                    <div class="col-md-8">
                      <ap-dropdown [list]="StateOptions" [selectType]="'single'" [showSearchbox]="true"
                                   [(ngModel)]="selectedStateItem" [ngModelOptions]="{standalone: true}"
                                   [title]="'** Please select a state name **'" [hideTitleOnInput]="true" [inputAriaLabel]="'State'" class="field-full-width"
                                   (onSelect)="stateChange($event)">
                        @for (item of StateOptions; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setAriaLabel(item, '** Please select a state name **')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                      </ap-dropdown>
                    </div>
                  </div>
}
                  @if (Choice204f === 'No') {
<div class="row">
                    <div class="col-md-4">
                      Province or State
                    </div>
                    <div class="col-md-8">
                      <dst-custom-input [label]="''" class="custom-input-100 w-100" [maxLength]="50" [value]="ProvOrStateOP" (valChange)="ProvOrStateOP = $event;"></dst-custom-input>
                    </div>
                  </div>
}
                  @if (Choice204f === 'No') {
<div class="row">
                    <div class="col-md-4">
                      Country
                    </div>
                    <div class="col-md-8">
                      <ap-dropdown [list]="CountryOptions" [selectType]="'single'" [showSearchbox]="true" [title]="'** Select Country **'" [inputAriaLabel]="'** Select Country **'"
                                   [(ngModel)]="selectedCountryItem" [ngModelOptions]="{standalone: true}"
                                   [hideTitleOnInput]="true" (onSelect)="countryChange($event)" class="field-full-width">
                        @for (item of CountryOptions; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                          [ariaLabel]="setAriaLabel(item, '** Select Country **')"
                          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
                      </ap-dropdown>
                    </div>
                  </div>
}
                  <br/>
                  <div class="row">
                    <div class="col-md-4">
                      Zip code
                    </div>
                    <div class="col-md-8 custom-input-wrapper">
                      <dst-custom-input class="required-field" [label]="''" [maxLength]="50" [value]="ZIPCodeOfOtherParty"
                                        (valChange)="ZIPCodeOfOtherParty = $event;"></dst-custom-input>
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <ol class="list-content m-0" start="2">
            <li style="counter-reset: count 1;">
              <div class="row">
                <div class="col-md-4">
                  Date of sale
                </div>
                <div class="col-md-8 date-align">
                  @if (nameChangeChecked) {
<app-date-picker-with-clear
                   
                    [minDate]="beginDate"
                    [maxDate]="endDate"
                    [datePickerClass]="'required-field'"
                    [required]="true"
                    (dateChange)="dateChange($event, 1)"
                    (datePickerClick)="onDPOpen()"
                    (clearClick)="clearDate(1)"
                    [(ngModel)]="DateOfSale"
                    [ngModelOptions]="{standalone: true}">
                  </app-date-picker-with-clear>
}
                </div>
              </div>
            </li>
            <li style="counter-reset: count 2;">
              <div class="row">
                <div class="col-md-4">
                  Total sales price (consideration)(For e-filing purposes, must be in USD)
                </div>
                <div class="col-md-3" style="margin-left: 0px;margin-right: -30px;padding-left: 0px;">
                  <ap-field [title]="''" [fieldId]="'1'" [type]="'appkit-number'" [format]="''" [styleClass]="'required-field total-sales number-field w-80'"
                    [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="TotalSalesPrice" [ngModelOptions]="{standalone: true}" [placeholder]="''" />
                  </ap-field>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </div>
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td>
            <strong>&nbsp;&nbsp;Part II</strong> &nbsp;&nbsp;
            <strong>Original Statement of Assets Transferred</strong>
          </td>
        </tr>
        </tbody>
      </table>
      <div formGroupName="partTwo" class="section-content ap-form-field-my-wrapper">
        <ol class="section-content list-content" start="4">
          <li style="counter-reset: count 3;">
            <div style="vertical-align: text-top;">
              <table class="table-layout w-100">
                <thead>
                <tr>
                  <td class="col-md-4 pt-0">
                    Assets
                  </td>
                  <td class="col-md-4 pt-0">
                    Aggregate fair market value<br/>
                    (actual amount for Class I)<br/>
                    (For e-filing purposes, must be in USD)
                  </td>
                  <td class="col-md-4 pt-0">
                    Allocation of sales price<br/>
                    (For e-filing purposes, must be in USD)
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Class I
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'2'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class1FMV" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 1)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'3'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class1ASP" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue({value: $event}, 7)" [placeholder]="''" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Class II
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'4'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class2FMV" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 2)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'5'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class2ASP" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue({value: $event}, 8)" [placeholder]="''" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Class III
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'6'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class3FMV" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 3)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'7'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class3ASP" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue({value: $event}, 9)" [placeholder]="''" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Class IV
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'8'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class4FMV" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 4)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'9'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class4ASP" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 10)" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Class V
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'10'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class5FMV" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 5)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'11'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class5ASP" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 11)" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Class VI and VII
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'12'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class6N7FMV" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 6)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'13'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-80'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class6N7ASP" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue({value: $event}, 12)" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-4 align-text-left">
                    Total
                  </td>
                  <td class="col-md-4 pr-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'14'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                        [styleClass]="'number-field w-80 total-field'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="TotalFMV" [ngModelOptions]="{standalone: true}" [placeholder]="'0'" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-4 pl-0">
                    <div class="d-flex part-two">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'15'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                        [styleClass]="'number-field w-80 total-field'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="TotalASP" [ngModelOptions]="{standalone: true}" [placeholder]="'0'" />
                      </ap-field>

                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </li>
          <li style="counter-reset: count 4;">
            <div class="row">
              <div class="col-md-9">
                Did the purchaser and seller provide for an allocation of the sales price in the sales contract or in
                another written document signed by both parties?

              </div>
              <div class="col-md-3">
                <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="'Yes'" [(ngModel)]="Choice204a" [ngModelOptions]="{standalone: true}" [name]="'radio-group-5'" (onChange)="check5a('Yes')" [styleClass]="'a-mx-10'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="'No'" [(ngModel)]="Choice204a" [ngModelOptions]="{standalone: true}" [name]="'radio-group-5'" (onChange)="check5a('No')" [styleClass]="'a-mx-10'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-md-9">
                If "Yes," are the aggregate fair market values (FMV) listed for each of asset Classes I, II, III, IV, V,
                VI, and VII the amounts agreed upon in your sales contract or in a separate written document?

              </div>
              <div class="col-md-3">
                <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="'Yes'" [(ngModel)]="Choice204b" [ngModelOptions]="{standalone: true}" [name]="'radio-group-6'" (onChange)="check5b('Yes')" [styleClass]="'a-mx-10'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="'No'" [(ngModel)]="Choice204b" [ngModelOptions]="{standalone: true}" [name]="'radio-group-6'" (onChange)="check5b('No')" [styleClass]="'a-mx-10'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
              </div>
            </div>
          </li>
          <br/>
          <li style="counter-reset: count 5;">
            <div class="row">
              <div class="col-md-9">
                In the purchase of the group of assets (or stock), did the purchaser also purchase a license or a
                covenant not to compete, or enter into a lease agreement, employment contract, management contract, or
                similar arrangement with the seller (or managers, directors, owners, or employees of the seller)?

              </div>
              <div class="col-md-3">
                <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="'Yes'" [(ngModel)]="Choice204c" [ngModelOptions]="{standalone: true}" [name]="'radio-group-7'" (onChange)="check6('Yes')" [styleClass]="'a-mx-10'">
                    <span>Yes</span>
                  </ap-radio>
                  <ap-radio [value]="'No'" [(ngModel)]="Choice204c" [ngModelOptions]="{standalone: true}" [name]="'radio-group-7'" (onChange)="check6('No')" [styleClass]="'a-mx-10'">
                    <span>No</span>
                  </ap-radio>
                </ap-radio-group>
              </div>
            </div>
            <div class="section-content" [hidden]="!(Choice204c === 'Yes')">
              <div class="row">
                <div class="col-md-12 pl-0">
                  <span>
                    If Yes, attach a schedule that specifies (a) the type of agreement and (b) the maximum amount of consideration (not including interest) paid or to be paid under the agreement. See instructions.
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 p-0">
                  <dst-custom-input class="custom-input-100 input-width w-100"
                                    [type]="'textarea'" [label]="''" [maxLength]="1000" [value]="ConsiderationCmptStatement"
                                    (valChange)="ConsiderationCmptStatement = $event;">
                  </dst-custom-input>
                </div>
              </div>
            </div>
          </li>
        </ol>
      </div>
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;Part III</strong> &nbsp;&nbsp;
            <strong>Supplemental Statement</strong>
          </td>
        </tr>
        </tbody>
      </table>
      <div formGroupName="partThree" class="section-content ap-form-field-my-wrapper">
        <div class="row">
          <div class="col-md-9 pr-0">
            Did you amend an original statement or previously filed supplemental statement because of an increase or
            decrease in consideration?
          </div>
          <div class="col-md-2">
            <ap-checkbox [ngModel]="editMode && Choice204d" [ngModelOptions]="{standalone: true}" (onChange)="check7($event)" [styleClass]="'a-mx-10'">
              <span>Yes</span>
            </ap-checkbox>
          </div>
        </div>
        <ol class="section-content list-content m-0" start="7" [hidden]="Choice204d !== true">
          <li style="counter-reset: count 6;">
            <div class="d-flex justify-content-between row">
              <div class="col-md-8 pr-0">
                Tax year and tax return form number with the original Form 8594 and any supplemental statements were
                filed.
              </div>
              <div class="col-md-2 d-flex">
                <span>Year</span>
                <ap-field [title]="''" [fieldId]="'16'" [styleClass]="'pl-2'" [hideTitleOnInput]="true" [style]="'width: 100px;'">
                  <input appkit-field [(ngModel)]="taxyear1" [ngModelOptions]="{standalone: true}" [placeholder]="''" />
                </ap-field>
              </div>
              <div class="col-md-2 d-flex">
                <span>Form</span>
                <ap-field [title]="''" [fieldId]="'17'" [styleClass]="'pl-2'" [hideTitleOnInput]="true" [style]="'width: 100px;'">
                  <input appkit-field [(ngModel)]="form1" [ngModelOptions]="{standalone: true}" [placeholder]="''" />
                </ap-field>
              </div>
            </div>
          </li>
          <br>
          <li style="counter-reset: count 7;">
            <div class="" style="vertical-align: text-top;">
              <table class="table-layout">
                <thead>
                <tr>
                  <td class="col-md-2 align-text-left">
                    Assets
                  </td>
                  <td class="col-md-3 p-0">
                    Allocation of sales price as previously reported<br/>
                    (For e-filing purposes, must be in USD)
                  </td>
                  <td class="col-md-3 p-0">
                    Increase or (decrease)<br/>
                    (For e-filing purposes, must be in USD)
                  </td>
                  <td class="col-md-4 p-0">
                    Redetermination of allocation of sales price<br/>
                    (For e-filing purposes, must be in USD)
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="col-md-3 align-text-left">
                    Class I
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'18'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class1PPR" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 1)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'19'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class1IncDec" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 13)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'20'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class1RASP" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue2({value: $event}, 7)" [placeholder]="''" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-3  align-text-left">
                    Class II
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'21'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class2PPR" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 2)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'22'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class2IncDec" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 14)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'23'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class2RASP" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue2({value: $event}, 8)" [placeholder]="''" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-3  align-text-left">
                    Class III
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'24'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class3PPR" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 3)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'25'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class3IncDec" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 15)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'26'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class3RASP" [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateValue2({value: $event}, 9)" [placeholder]="''" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-3  align-text-left">
                    Class IV
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'27'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class4PPR" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 4)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'28'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class4IncDec" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 16)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'29'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class4RASP" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 10)" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-3  align-text-left">
                    Class V
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'30'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class5PPR" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 5)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'31'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class5IncDec" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 17)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'32'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class5RASP" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 11)" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-3  align-text-left">
                    Class VI and VII
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'33'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class6N7PPR" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 6)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'34'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class6N7IncDec" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 18)" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'35'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field w-100'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="Class6N7RASP" [ngModelOptions]="{standalone: true}"
                          [placeholder]="''" (ngModelChange)="updateValue2({value: $event}, 12)" />
                      </ap-field>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="col-md-3 align-text-left">
                    Total
                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'36'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                        [styleClass]="'number-field w-100 total-field'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="TotalPPR" [ngModelOptions]="{standalone: true}" [placeholder]="'0'" />
                      </ap-field>
                    </div>
                  </td>
                  <td class="col-md-3">

                  </td>
                  <td class="col-md-3">
                    <div class="d-flex part-two part-two--fixed-number-field">
                      <span class="currency-prefix">$</span>
                      <ap-field [title]="''" [fieldId]="'37'" [type]="'appkit-number'" [format]="''" [disabled]="true"
                        [styleClass]="'number-field w-100 total-field'" [hideTitleOnInput]="true">
                        <input appkit-field [(ngModel)]="TotalRASP" [ngModelOptions]="{standalone: true}" [placeholder]="'0'" />
                      </ap-field>

                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </li>
        </ol>
        <ol start="9" class="section-content list-content m-0">
          <li style="counter-reset: count 8;">
            <dst-custom-input class="custom-input-100 input-width w-100"
                              [type]="'textarea'" [label]="''" [maxLength]="1000" [value]="RsnForIncOrDec"
                              (valChange)="RsnForIncOrDec = $event;">
            </dst-custom-input>
          </li>
        </ol>
      </div>
      <dst-template-leid-selector [isBranchEntity]="true" [label]="'Please specify the LEID of the Branch Entity:'"
        [labelId]="'3'" (onSelectedLEChanged)="onBranchEntityChanged($event)" class="entity-label">
      </dst-template-leid-selector>
      <div class="entity-details">
        <span>Branch Entity Name:</span><span class="template-color-blue branch-entity-align">{{!branchEntity ? '' :
                                                                            branchEntity.ENTITY}}</span>
      </div>
      <div class="leid-list d-flex" style="margin-top: 15px;">
        <span>LEIDs: </span>
        <div>
          @if (transferee) {
<span class="template-color-blue">{{ transferee.LEID }}</span>
}@if (transferor) {
<span> /
          </span>
}@if (transferor) {
<span class="template-color-blue">{{ transferor.LEID }}</span>
}
        </div>
      </div>
      <div>
          <span style="height: 100px;"></span>
      </div>
    </div>
  </div>
</div>
